export interface UseShakeOptions {
  duration?: number
  delay?: number
}

export interface UseShakeReturn {
  isShaking: Ref<boolean>
  shakeClass: Ref<string>
  triggerShake: () => void
}

export function useAnimationShake(
  trigger: () => any,
  options: UseShakeOptions = {},
): UseShakeReturn {
  const { duration = 400, delay = 0 } = options

  const isShaking = ref<boolean>(false)
  const shakeClass = computed(() => {
    if (!isShaking.value)
      return ''

    return 'animation-shake'
  })

  let timeoutId: ReturnType<typeof setTimeout>

  const startShake = () => {
    isShaking.value = true

    timeoutId = setTimeout(() => {
      isShaking.value = false
    }, duration)
  }

  const triggerShake = () => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    if (delay > 0) {
      timeoutId = setTimeout(() => {
        startShake()
      }, delay)
    }
    else {
      startShake()
    }
  }

  watch(trigger, (newValue, oldValue) => {
    if (newValue && !oldValue) {
      triggerShake()
    }
  })

  onUnmounted(() => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
  })

  return {
    isShaking,
    shakeClass,
    triggerShake,
  }
}
